/**
Language Switcher
Event listener on language menu. When a language link is clicked,
a cookie is set and the page is reloaded.
*/

var initializeLanguageSwitcher = function() {

	// when a language is clicked, set cookie and reload page with query string
	function handleLanguageSelection(e) {
		e.preventDefault();
		var language = this.getAttribute('data-lang');
		var date = new Date();
		date.setTime(date.getTime() + 86400000000);
		document.cookie = 'I18N_LANGUAGE=' + language + '; expires=' + date.toUTCString() + '; path=/';
		if (typeof removeUrlParam != 'undefined') {
			parent.location.href = removeUrlParam(window.location.href, 'siteLanguage');
		} else {
			parent.location.href = window.location.href;
		}
		if (window.location.hash.length) {
			location.reload();
		}
	}

	// add click event listener to all language links
	var languageLinks = document.querySelectorAll('[data-lang]');

	for (var languageLinkIndex = 0; languageLinkIndex < languageLinks.length; languageLinkIndex++) {
		languageLinks[languageLinkIndex].addEventListener('click', handleLanguageSelection);
	}
};

document.addEventListener('lichen:loaded', initializeLanguageSwitcher);
